"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _RelayMetricHandler_cache;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayMetricHandler = void 0;
class RelayMetricHandler {
    constructor(cache) {
        _RelayMetricHandler_cache.set(this, void 0);
        __classPrivateFieldSet(this, _RelayMetricHandler_cache, cache, "f");
    }
    onDisconnect(c, code) { }
}
exports.RelayMetricHandler = RelayMetricHandler;
_RelayMetricHandler_cache = new WeakMap();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVsYXktbWV0cmljLWhhbmRsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcmVsYXktbWV0cmljLWhhbmRsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUlBLE1BQWEsa0JBQWtCO0lBRzdCLFlBQVksS0FBOEI7UUFGakMsNENBQWdDO1FBR3ZDLHVCQUFBLElBQUksNkJBQVUsS0FBSyxNQUFBLENBQUM7SUFDdEIsQ0FBQztJQUVELFlBQVksQ0FBQyxDQUFhLEVBQUUsSUFBWSxJQUFHLENBQUM7Q0FDN0M7QUFSRCxnREFRQyJ9